import { Component, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { HeaderShellComponent } from '../header-shell/header-shell.component';

@Component({
  selector: 'grid-engine-basic-header-cell',
  templateUrl: './empty-header-cell.component.html',
  imports: [HeaderShellComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./empty-header-cell.component.scss']
})
export class EmptyHeaderCellComponent implements IHeaderAngularComp {
  params: WritableSignal<IHeaderParams> = signal(null);

  agInit(params: IHeaderParams): void {
    this.params.set(params);
  }

  refresh(): boolean {
    return false;
  }
}
